/**
 * Testi default widget Price Alert **in italiano** lato server (DB / restore / webhook).
 * Devono coincidere carattere per carattere con
 * `app.carthub.cloud/src/constants/priceAlertWidgetSettings.js` → PRICE_ALERT_WIDGET_DEFAULTS
 * per le sole chiavi stringa elencate sotto.
 *
 * Uso dashboard: se GET /settings restituisce ancora questi valori, il form li tratta come
 * «non personalizzati» e mostra placeholder + anteprima dalla lingua UI (i18n).
 */
export const PA_WIDGET_SERVER_TEXT_DEFAULTS_IT = Object.freeze({
  price_alert_widget_title: "Ti avvisiamo noi se il prezzo scende",
  price_alert_widget_email_placeholder: "La tua email",
  price_alert_widget_cta_label: "Avvisami",
  price_alert_widget_submitting_label: "Invio…",
  price_alert_widget_footer_text:
    "Inserendo la tua email accetti di ricevere aggiornamenti sul prezzo di questo prodotto. {privacy}",
  price_alert_widget_success_text: "Ti avviseremo se il prezzo cambia",
});

/** @param {string} col @param {string|null|undefined} val */
export function paWidgetValueIfNotItalianServerDefault(col, val) {
  const expected = PA_WIDGET_SERVER_TEXT_DEFAULTS_IT[col];
  if (expected == null) return val ?? "";
  const s = String(val ?? "").trim();
  if (s === String(expected).trim()) return "";
  return String(val ?? "");
}
